import { configureStore } from '@reduxjs/toolkit'
import authSlice from './slices/authSlice'
import errorSlice from './slices/errorSlice'
import platformSlice from './slices/platformSlice'
import connectedPlatformSlice from './slices/connectedPlatformSlice'
import fetchConnectedPlatformSlice from './slices/fetchConnectedPlatformSlice'
import retrivePlatformDataSlice from './slices/retrivePlatformDataSlice'
import createPlatformSettingsSlice from './slices/createPlatformSettingsSlice'
import orderSlice from './slices/orderSlice'
import productSlice from './slices/productSlice'
import deletePlatformDataSlice from './slices/deletePlatformData.Slice'
import orderDetailSlice from './slices/orderDetailSlice'
import fetchTemuCountrySlice from './slices/fetchTemuCountrySlice'
import fetchAvailablePlatformSlice from './slices/fetchAvailablePlatformSlice'
import fetchUserAccountDataSlice from './slices/fetchUserAccountDataSlice'
import productVarientSlice from './slices/productVarientSlice'
import linkProductVarientSlice from './slices/linkProductVarientSlice'
import productVarientFromMainSlice from './slices/productVarientFromMainSlice'
import uploadSlice from './slices/uploadSlice'
import templateAndPricingSlice from './slices/templateAndPricingSlice'
import platformRepricingSlice from './slices/platformRepricingSlice'
import userInviteSlice from './slices/userInviteSlice'
import customerSlice from './slices/customerSlice'
import platformSettingSlice from './slices/platformSettingSlice'
import pricingSlice from './slices/pricingSlice'
import tourPopupSlice from './slices/tourPopupSlice'
import inventorySlice from './slices/inventorySlice'
import priceLogsSlice from './slices/priceLogsSlice'
import generateMfaQrCodeReducer from "./slices/fetchMfaQrcode"
import verifyMfaCodeAsyncSlice from "./slices/VerifyMfaCodeSlice"
import customFieldsSlice from "./slices/customFieldSlice"
import historyLogsSlice from "./slices/historyLogsSlice"
import invoiceDetailGenerationSlice from "./slices/invoiceDetailsGenerateSlice"
import activeBundleSlice from "./slices/actionBundleSlice"
import ruleBuilderSlice from "./slices/ruleBuilderSlice"
import newhistoryLogsSlice from "./slices/newhistoryLogsSlice";
import omsCustomFieldsSlice from "./slices/omsCustomFieldsSlice"
import warehouseSlice from "./slices/warehouseSlice"
import inventoryAdjustmentSlice from "./slices/inventoryAdjustmentSlices"
import inventoryTransferSlice from "./slices/inventoryTransferSlice"
import groupedProductSlice from "./slices/GroupedProductTableSlice"
import groupedViewLiteSlice from "./slices/GroupedViewLiteSlice"
import cookieConsentSlice from './slices/cookieConsentSlice'

import orderPackageSlice from './slices/orderPackageSlice'
import packageSlice from './slices/packageSlice'
import omsShippingSlice from './slices/omsShippingSlice'
import omsCustomerSlice from './slices/omsCustomerSlice'
import omsOrderSlice from './slices/omsOrderSlice'
// ...


export const store = configureStore({
  reducer: {
    testReducer: () => {
      return null
    },
    auth: authSlice,
    platform: platformSlice,
    connectedPlatform: connectedPlatformSlice,
    fetchConnectedPlatform: fetchConnectedPlatformSlice,
    retrivePlatformData: retrivePlatformDataSlice,
    createPlatformSettings: createPlatformSettingsSlice,
    deletePlatformData: deletePlatformDataSlice,
    error: errorSlice,
    order: orderSlice,
    productsOfSingleChannel: productSlice,
    orderDetailsData: orderDetailSlice,
    fetchTemuCountry: fetchTemuCountrySlice,
    fetchAvailablePlatformSync: fetchAvailablePlatformSlice,
    userAccountData: fetchUserAccountDataSlice,
    productVarientsOfSingleChannel: productVarientSlice,
    linkProductVarient: linkProductVarientSlice,
    productVarientFromMain: productVarientFromMainSlice,
    uploadCsv: uploadSlice,
    templateAndPricing: templateAndPricingSlice,
    platformRepricing: platformRepricingSlice,
    userInvite: userInviteSlice,
    customer: customerSlice,
    platformSetting: platformSettingSlice,
    pricing: pricingSlice,
    tourPopup: tourPopupSlice,
    inventory: inventorySlice,
    priceLogs: priceLogsSlice,
    mfaQrCode: generateMfaQrCodeReducer,
    verifymfacode: verifyMfaCodeAsyncSlice,
    customFieldsSlice: customFieldsSlice,
    historyLogs: historyLogsSlice,
    invoiceDetailGenerationSlice: invoiceDetailGenerationSlice,
    activeBundleSlice: activeBundleSlice,
    ruleBuilderSlice: ruleBuilderSlice,
    newhistoryLogsSlice: newhistoryLogsSlice,
    warehouseSlice: warehouseSlice,
    inventoryAdjustmentSlice: inventoryAdjustmentSlice,
    inventoryTransferSlice: inventoryTransferSlice,
    omsCustomFieldsSlice: omsCustomFieldsSlice,
    groupedProductSlice: groupedProductSlice,
    groupedViewLiteSlice: groupedViewLiteSlice,
    cookieConsent: cookieConsentSlice,

    orderPackageSlice: orderPackageSlice,
    packageSlice: packageSlice,
    omsShipping: omsShippingSlice,
    omsCustomer: omsCustomerSlice,
    omsOrder: omsOrderSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
